import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';

/**
 * A single dashboard/stat tile: centered icon, big value, muted label.
 * Reconciles the two previous stat-card shapes (Dashboard's tall
 * CardHeader/CardTitle variant and the other pages' `CardContent p-4 text-center`
 * variant) into one. When `onClick` is provided the card becomes an accessible
 * button-like control with a hover affordance.
 */
const StatCard = ({ icon: Icon, value, label, onClick, testId, valueClassName, iconClassName }) => {
  const clickable = typeof onClick === 'function';
  return (
    <Card
      data-testid={testId}
      onClick={onClick}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
      onKeyDown={
        clickable
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      className={cn(
        clickable &&
          'cursor-pointer hover:shadow-md transition-shadow focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring'
      )}
    >
      <CardContent className="p-4 text-center">
        {Icon ? <Icon className={cn('text-accent mx-auto mb-2 shrink-0', iconClassName)} size={24} /> : null}
        <p className={cn('font-serif text-2xl font-bold text-primary', valueClassName)}>{value}</p>
        <p className="text-sm text-muted-foreground mt-1">{label}</p>
      </CardContent>
    </Card>
  );
};

export default StatCard;
